import { render } from "./NavigationComp.vue?vue&type=template&id=5e675ffc&scoped=true"
import script from "./NavigationComp.vue?vue&type=script&lang=js"
export * from "./NavigationComp.vue?vue&type=script&lang=js"

import "./NavigationComp.vue?vue&type=style&index=0&id=5e675ffc&scoped=true&lang=scss"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e675ffc"]])

export default __exports__